import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, timer } from 'rxjs';
import { catchError, concatMap, map, mergeMap } from 'rxjs/operators';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import * as mainActions from 'src/app/state/app.actions';
import { mainState } from './app.reducer';


@Injectable()
export class appEffects {

  constructor(private actions$: Actions, private store$: Store<mainState>, private DashboardsService: DashboardService) { }

    removeMessage$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(mainActions.addMessage),
                concatMap((m) =>
                    timer(5000)
                        .pipe(map(() => mainActions.removeMessage({ message: m.message })))
                ))
    });

    getUserInfo$ = createEffect(() => {
      return this.actions$
        .pipe(
          ofType(mainActions.loadUserInfo),
          mergeMap(() => this.DashboardsService.getUserInfo()
            .pipe(
              map(userInfo => mainActions.loadUserInfoSuccess({ userInfo })),
                catchError(error => of(mainActions.loadFailure({ error })))
            )
          )
        );
    });
}
